import api from "../Services/AxiosInstance";

export class FactureService {
 
  getAllFacturetByPeriod9 = async ( reçue,period, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/Facture/Dashboard/list/${reçue}/${period}?dateDeb=${dateDeb}&dateFin=${dateFin}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  getAllFacturetByPeriod = async (reçue, period) => {
    try {
      const response = await api.get(
        `/Facture/Dashboard/list/${reçue}/${period}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
}
